import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { FloorNumbersParams } from './service';

export enum FloorNumbersActions {
  Failure = '[Catalogs FloorNumbers] Failure',
  Request = '[Catalogs FloorNumbers] Request',
  Success = '[Catalogs FloorNumbers] Success',
}

export const FloorNumbersFailure = createAction(FloorNumbersActions.Failure, props<{ error: HttpErrorResponse }>());

export const FloorNumbersRequest = createAction(
  FloorNumbersActions.Request,
  props<{ parameters?: FloorNumbersParams }>()
);

export const FloorNumbersSuccess = createAction(FloorNumbersActions.Success, props<{ data: ParameterResult[] }>());
